import type { DebugTier } from '../DebugPanel/staticDatasets';

// ---------------------------------------------------------------------------
// Field/value IDs
// ---------------------------------------------------------------------------

export const CURRENT_VIEW_FIELD_ID = 'customfield_13180';
export const CURRENT_VIEW_LOGGED_IN_VALUE_ID = '13094';
export const CURRENT_VIEW_LOGGED_OUT_VALUE_ID = '13095';

export const VIEW_VERSION_FIELD_ID = 'customfield_13181';
export const VIEW_VERSION_USER_VALUE_ID = '13096';
export const VIEW_VERSION_ORG_VALUE_ID = '13097';
export const VIEW_VERSION_BASE_VALUE_ID = '13098';

export const ATTACHMENT_FIELD_ID = 'attachment';

/**
 * Maps the currently displayed tier to the corresponding viewVersion value ID
 * used in the hidden feedback field.
 *
 * tier1 (UserGraphView)       → user view    (VIEW_VERSION_USER_VALUE_ID)
 * tier2 (OrgGraphView)        → org view     (VIEW_VERSION_ORG_VALUE_ID)
 * tier3 (GettingStartedView)  → base view    (VIEW_VERSION_BASE_VALUE_ID)
 */
export function getViewVersionValueId(tier: DebugTier): string {
	switch (tier) {
		case 'tier1':
			return VIEW_VERSION_USER_VALUE_ID;
		case 'tier2':
			return VIEW_VERSION_ORG_VALUE_ID;
		case 'tier3':
		default:
			return VIEW_VERSION_BASE_VALUE_ID;
	}
}
